export const main = (filters) => [
  {text: '', value: 'actions', width: 100},
  { text: 'ID', align: 'start', value: 'id', width: '5rem',  
      filter: value => {
                  if ( !filters.find(x=>x.name === 'id')?.value) return true
                  return value == filters.find(x=>x.name === 'id')?.value
      }
  },
  // { text: 'Tháng khởi tạo', align: 'start', value: 'employeeReadyReviewMonth', width: '7rem',
  //     filter: value => true
  // },
  
  { text: 'Nhóm', align: 'start', value: 'group', width: '12rem',
      filter: value => {
                  if ( !filters.find(x=>x.name === 'group')?.value) return true
                  return value.includes(filters.find(x=>x.name === 'group')?.value)
      }
  },
  { text: 'Tiêu đề', align: 'start', value: 'title', width: '20rem',  
      filter: value => {
        if ( !filters.find(x=>x.name === 'title')?.value) return true
        return value.includes(filters.find(x=>x.name === 'title')?.value)
      }
  },
  { text: 'Chi tiết', align: 'start', value: 'body', width: '20rem',  
      filter: value => {
        if ( !filters.find(x=>x.name === 'body')?.value) return true
        return value.includes(filters.find(x=>x.name === 'body')?.value)
      }
  },
  
  { text: '', align: 'start', value: 'createdAt', width: '20rem',  
      filter: value => {
        if ( !filters.find(x=>x.name === 'createdAt')?.value) return true
        return value.includes(filters.find(x=>x.name === 'createdAt')?.value)
      }
  },
  
  { text: 'Tháng', align: 'start', value: 'monthNo', width: '20rem',  
      filter: value => {
        if ( !filters.find(x=>x.name === 'monthNo')?.value) return true
        return value.includes(filters.find(x=>x.name === 'monthNo')?.value)
      }
  },
]

export const view = (filters) => [
//   {text: '', value: 'actions', width: 100},
  { text: 'ID', align: 'start', value: 'id', width: '5rem',  
      filter: value => {
                  if ( !filters.find(x=>x.name === 'id')?.value) return true
                  return value == filters.find(x=>x.name === 'id')?.value
      }
  },
  
  { text: 'Nhóm', align: 'start', value: 'conditionGroup', width: '10rem',},
  { text: 'Điều kiện', align: 'start', value: 'conditionTitle' },
  
  { text: 'Đánh giá', align: 'start', value: 'score' }
]

export const finalHeaders = [
  {text: '', value: 'actions', width: 100},
  { text: 'Tháng', align: 'start', value: 'month', width: '7rem' },
  { text: 'Chưa hoàn tất NVM', align: 'start', value: 'incompleteNvm' },
  { text: 'Hoàn tất NVM', align: 'start', value: 'completeNvm' },
  { text: 'Tổng phiếu NVM', align: 'start', value: 'totalReviewNvm' },
  { text: 'Chưa hoàn tất COT2', align: 'start', value: 'incompleteCot2' },
  { text: 'Hoàn tất COT2', align: 'start', value: 'completeCot2' },
  { text: 'Tổng phiếu COT2', align: 'start', value: 'totalReviewCot2' },
]

export const readyHeaders = [
  { text: 'Mã nhân viên', align: 'start', value: 'employeeCode' },
  { text: 'Tên nhân viên', align: 'start', value: 'employeeName' },
  { text: 'Phân loại', align: 'start', value: 'type' },
  { text: 'Mã NS đánh giá', align: 'start', value: 'finalManagerCode' },
  { text: 'Người đánh giá', align: 'start', value: 'finalManagerName' },
  { text: 'Chỉ định người đ/giá (tạm thời)', align: 'start', value: 'smCode' },
]